import React, { useEffect, useState } from 'react';
import { Drawer, Form, Button } from 'antd';
import useStore from 'store/marketing-activities/apply-list';
import SPDynamicFormRender from 'components/base/SPDynamicFormRender';
import ChooseCarModelByStore from './choose-car-model-by-store';

import useBaseStore from 'store/base';
import './index.css';

type Iprops = {
  data: any;
}

const SPDrawer:React.FC<Iprops> = (props) => {

  const { data } = props;

  const { enums } = useBaseStore((state: any) => ({ ...state }));

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);

  const [form] = Form.useForm();

  const { drawerOpen, drawerType = 'add', closeDrawer, activityApply, activityApplyUpdate,
    targetRecord, fetchDetail, fetchList, searchData, 
  } = useStore(state => ({ ...state }));

  const handleClose = () => {
    closeDrawer();
    form.resetFields();
  }

  const handleSubmit = () => {
    const value = form.getFieldsValue();
    form.validateFields().then((value: any) => {
      const { act_reg_price_mod_status, act_reg_store_status, city_store_list, price_mod_code_list } = value || {};
      const { action_code, reg_code } = targetRecord as any || {};
      const requestMethod = reg_code ? activityApplyUpdate : activityApply;
      requestMethod({
        reg_code,
        action_code,
        action_source: 2,
        store_enroll: {
          type: act_reg_store_status,
          store_codes: act_reg_store_status ? city_store_list : []
        },
        price_mod_enroll: {
          type: act_reg_price_mod_status,
          price_codes: act_reg_price_mod_status ? price_mod_code_list : []
        },
      }).then((() => {
        fetchList({ ...searchData, page: 1 });
        closeDrawer();
      }));
    });
  }

  const drawerExtra = () => {
    const Bar = <>
      <Button onClick={handleClose} style={{ marginRight: '12px' }}>取消</Button>
      <Button type='primary' onClick={handleSubmit}>提交</Button>
    </>
    if (drawerType === 'add') {
      return Bar;
    }
    if (drawerType === 'edit') {
      return Bar;
    }
    if (drawerType === 'view') {
      return (
        <></>
      )
    }
    return null;
  }

  useEffect(() => {
    if (drawerOpen) {
      const { action_code, activity_cities, activity_veh_group } = targetRecord as any || {};
      if (action_code) {
        setIsLoadingDetail(true);
        fetchDetail({ action_code }).then(res => {
          const {
            action_name, action_time, action_tag, action_desc, reg_time,
            attention, store_enroll_type, price_mod_enroll_type,
            city_store_list, price_mod_code_list, cost_bear_metd,
            holiday, amount_limit, discount_plan, cost_bear_per,
            overlay_discounts, action_images, pick_up_and_return_veh_time
          } = res?.data || {};
          const params = {
            action_name,
            action_time: action_time?.join(' 至 '),
            action_desc,
            action_tag,
            action_images,
            reg_time: reg_time?.join(' 至 '),
            attention,
            act_reg_store_status: store_enroll_type,
            act_reg_price_mod_status: price_mod_enroll_type,
            city_store_list,
            price_mod_code_list,
            cost_bear_metd,
            activity_cities,
            activity_veh_group,
            holiday: Number(holiday),
            amount_limit: amount_limit ? `${amount_limit / 100}元` : '不限制',
            discount_plan,
            cost_bear_per,
            overlay_discounts: overlay_discounts && overlay_discounts[0],
            pick_up_and_return_veh_time
          };
          form.setFieldsValue(params);
          setIsLoadingDetail(false);
        }).catch(() => {
          setIsLoadingDetail(false);
        });
      }
    }
  }, [drawerOpen]);

  return (
    <Drawer title="活动详情" width='75%' placement="right" onClose={handleClose} open={drawerOpen} extra={drawerExtra()}>
      <Form className='activity-form-apply' form={form} disabled={drawerType === 'view'}>
        <SPDynamicFormRender data={data} enums={enums} />
        {!isLoadingDetail && <ChooseCarModelByStore enums={enums} actionCode={(targetRecord as any)?.action_code} />}
      </Form>
    </Drawer>
  )
}

export default SPDrawer;